import React, {
    useContext,
    useState,
    useEffect,
    useRef
} from 'react';
import { Navigate, Link } from "react-router";
import { useQuery, useMutation } from '@tanstack/react-query';

import { getCustomer, refetchCustomer, NotificationContext, handleError } from "../router"

import * as CONSTANTS from "../constants";
import * as QUERIES from "../query-functions";
import * as UTILS from "../utils";
import * as OPTIONS from "../option-fields";

import LoadingIndicator from '../components/loading-indicator';

const PreferencesBlock = () => {

    const {notification, setNotification} = useContext(NotificationContext);
    const { data: customer, isPending, isFetching } = getCustomer();

    const [customerTagIds, setCustomerTagIds] = useState(UTILS.getCustomerTagIds(customer?.tags));
    const [title, setTitle] = useState(null);
    const [introduction, setIntroduction] = useState(null);
        
    const addCustomerTag = useMutation({
        mutationFn: (tagId) => QUERIES.addCustomerTag([{id: tagId}]),
        onError: (error) => {
            handleError(error.message, setNotification);
        },
        onSuccess: (data) => {
            refetchCustomer();
        }
    })

    const removeCustomerTag = useMutation({
        mutationFn: (tagId) => QUERIES.removeCustomerTag(tagId),
        onError: (error) => {
            handleError(error.message, setNotification);
        },
        onSuccess: (data) => {
            refetchCustomer();
        }
    })

    const submitForm = (e) => {
        if (!e) return;
        e.preventDefault();

        // Get the id's of checked checkboxes
        const new_checked_values = Array.from(e.target.tag)
                .map((el) => { if (el.checked) return el.id; })
                .filter((id) => id !== undefined);

        // Map which id's have been added and removed
        const added_ids = new_checked_values.filter(id => !customerTagIds?.includes(id));
        const removed_ids = customerTagIds.filter(id => !new_checked_values?.includes(id));

        // Add or remove them in Spektrix
        added_ids?.forEach((id) => {
            addCustomerTag.mutateAsync(id);
        });
        removed_ids?.forEach((id) => {
            removeCustomerTag.mutateAsync(id);
        });
    }

    useEffect(() => {
        if (!customer) return;

        // getCustomerTagIds filters tags CONSTANTS.TAGS so should be used instead of customer.tags
        const new_customer_tag_ids = UTILS.getCustomerTagIds(customer?.tags);

        if (new_customer_tag_ids?.length) {
            setTitle(OPTIONS.account.preferences_saved.title?.innerHTML);
            setIntroduction(OPTIONS.account.preferences_saved.title?.innerHTML);
        } else {
            setTitle(OPTIONS.account.preferences_not_saved.introduction?.innerHTML);
            setIntroduction(OPTIONS.account.preferences_not_saved.introduction?.innerHTML);
        }

        setCustomerTagIds(new_customer_tag_ids);
    }, [customer]);
    
    return (
        <section className='preferences-block'>
            {addCustomerTag.isPending || removeCustomerTag.isPending ?
                <LoadingIndicator />
            :
                <>
                    <h2 className='booking-pathway__header' dangerouslySetInnerHTML={{__html: title}}></h2>
                    <div className='booking-pathway__introduction' dangerouslySetInnerHTML={{__html: introduction}}></div>
                    <form className='preferences-block--form' onSubmit={submitForm}>
                        <div className='preferences-block--form-fields'>
                            {CONSTANTS.TAGS.map((pref) => (
                                <div key={pref.id} className="form-field">
                                    <input type="checkbox" 
                                            name="tag" 
                                            id={pref.id}
                                            value={pref.id}
                                            defaultChecked={customerTagIds?.includes(pref.id)} />
                                    <label htmlFor={pref.id} className='btn--pill'>{pref.name}</label>
                                </div>
                            ))}
                        </div>
                        <button type="submit" className='btn'>Save</button>
                    </form>
                </>
            }
        </section>
    );
};

export default PreferencesBlock;
